var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal-content"},[_c('h2',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }